<form [formGroup]="formGroup" class="painad">
  @for (element of elements; track element.name; let i = $index) {
    @if (element.type === "radiogroup") {
      <div class="painad-row">
        <div class="painad-q">
          <div class="painad-q-title">
            <span>{{ i + 1 }}. {{ getQuestionTitle(element.title) }}</span>
          </div>
          @if (getQuestionInstruction(element.title)) {
            <div class="painad-instruction">
              {{ getQuestionInstruction(element.title) }}
            </div>
          }
        </div>
        <div class="painad-a">
          <div class="painad-group">
            @for (choice of element.choices; track choice.value) {
              <label class="painad-option">
                <input
                  type="radio"
                  [formControlName]="element.name"
                  [value]="choice.value"
                  (click)="onRadioClick(element.name, choice.value)"
                />
                <span class="painad-option-text">{{
                  choice.text
                }}</span>
              </label>
            }
          </div>
        </div>
      </div>
    }
    @if (element.type === "text" && !isTotalScoreElement(element)) {
      <div>
        <div fxLayout="row" fxLayoutAlign="center center" class="label-row">
          <div
            fxLayout="col"
            fxFlex="100"
            class="add-patient-col"
            fxLayoutAlign="start center"
          >
            <b class="title">{{ getQuestionTitle(element.title) }}</b>
            @if (!readonlyMode && (isInpatientView() || isEOC())) {
              <button
                nz-button
                nzType="primary"
                type="button"
                (click)="setNotMentioned(element.name)"
                class="quick-button"
                [disabled]="!hasPermission(['a-sqa'])"
              >
                {{ "Not mentioned" | translate }}
              </button>
            }
          </div>
        </div>
        @if (getQuestionInstruction(element.title)) {
          <div class="instruction-row">
            <div fxLayout="col" fxFlex="100" class="add-patient-col">
              <div class="question-instruction">
                {{ getQuestionInstruction(element.title) }}
              </div>
            </div>
          </div>
        }
        <div
          fxLayout="row"
          fxLayoutAlign="center center"
          class="add-patient-row"
        >
          <div fxLayout="col" fxFlex="100" class="add-patient-col">
            <input
              type="text"
              class="add-patient-input"
              [formControlName]="element.name"
            />
          </div>
        </div>
      </div>
    }
  }

  <div class="painad-total">
    <div class="painad-total-title">{{ "Score" | translate }}</div>
    <div class="painad-total-score">{{ totalScore }} / {{ maxScore }}</div>
  </div>
</form>
